import { Roles } from "../../../constants/roles";
import { SearchUserModalHandler } from "./search-user-modal-handler";
import { SearchUserModalListener } from "./search-user-modal-listener";
import { searchUserModalForm } from "./search-user-modal-form";

const handlersByOverlay = new WeakMap<HTMLElement, SearchUserModalHandler>();

export class SearchProductUpdatedByModalSetup {
    public static init(rootEl: Document | HTMLElement = document): SearchUserModalHandler | null {
        const overlayEl = searchUserModalForm.getOverlay(rootEl, Roles.SEARCH_PRODUCT_UPDATED_BY_MODAL_OVERLAY);
        const modalEl = searchUserModalForm.getModal(rootEl, Roles.SEARCH_PRODUCT_UPDATED_BY_MODAL);
        const listRootEl = searchUserModalForm.getListRoot(rootEl, Roles.SEARCH_PRODUCT_UPDATED_BY_MODAL_LIST);
        const closeBtnEl = searchUserModalForm.getCloseButton(rootEl, Roles.SEARCH_PRODUCT_UPDATED_BY_MODAL_CLOSE);
        const filterInputEl = searchUserModalForm.getFilterInput(rootEl, Roles.SEARCH_PRODUCT_UPDATED_BY_MODAL_FILTER);

        if (
            !(overlayEl instanceof HTMLElement) ||
            !(modalEl instanceof HTMLElement) ||
            !(listRootEl instanceof HTMLElement)
        ) {
            return null;
        }

        const existing = handlersByOverlay.get(overlayEl);
        if (existing) return existing;

        const handler = new SearchUserModalHandler({
            overlayEl,
            modalEl,
            listRootEl,
            filterInputEl,
        });

        SearchUserModalListener.setup({
            rootEl,
            scopeKey: "search-product-updated-by-modal",
            overlayEl,
            modalEl,
            closeBtnEl,
            listRootEl,
            filterInputEl,
            handler,
        });

        handlersByOverlay.set(overlayEl, handler);
        return handler;
    }
}
